import React, { useState } from 'react'
import './UsageDataTable.css'

const UsageDataTable = ({ data }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredData, setFilteredData] = useState(data)

  React.useEffect(() => {
    if (searchTerm === '') {
      setFilteredData(data)
    } else {
      const filtered = data.filter(item =>
        item.businessName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.user.toLowerCase().includes(searchTerm.toLowerCase())
      )
      setFilteredData(filtered)
    }
  }, [searchTerm, data])

  const handleExportCSV = () => {
    const headers = ['Business Name', 'API Calls', 'Tokens Used', 'User', 'Avg. Latency']
    const csvContent = [
      headers.join(','),
      ...filteredData.map(item =>
        [
          item.businessName,
          item.apiCalls,
          item.tokensUsed,
          item.user,
          item.avgLatency
        ].join(',')
      )
    ].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'usage-reports.csv'
    a.click()
    window.URL.revokeObjectURL(url)
  }

  return (
    <div className="data-table-container">
      <div className="data-table-header">
        <div className="search-container">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <button className="export-btn" onClick={handleExportCSV}>
          Export CSV
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2L8 10M8 10L5 7M8 10L11 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 12L2 13C2 13.5523 2.44772 14 3 14L13 14C13.5523 14 14 13.5523 14 13L14 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
      
      <div className="table-wrapper">
        <table className="usage-table">
          <thead>
            <tr>
              <th>Business Name</th>
              <th>API Calls</th>
              <th>Tokens Used</th>
              <th>User</th>
              <th>Avg. Latency</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, index) => (
              <tr key={index}>
                <td>{item.businessName}</td>
                <td>{item.apiCalls.toLocaleString()}</td>
                <td>{item.tokensUsed.toLocaleString()}</td>
                <td>{item.user}</td>
                <td>{item.avgLatency}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default UsageDataTable













